import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { HashLink } from 'react-router-hash-link';

import { generatePopUpLink } from './utils';

// eslint-disable-next-line react/prefer-stateless-function
class PopUpLink extends Component {
  render() {
    return (
      <HashLink
        className={this.props.className}
        to={generatePopUpLink(
          this.props.location,
          this.props.hashName,
          this.props.hashParams
        )}
      >
        {this.props.children}
      </HashLink>
    );
  }
}

PopUpLink.defaultProps = {
  className: '',
  hashParams: {}
};

PopUpLink.propTypes = {
  children: PropTypes.node.isRequired,
  // IN
  className: PropTypes.string,
  hashName: PropTypes.string.isRequired,
  hashParams: PropTypes.shape(PropTypes.shape),
  // withRouter
  location: PropTypes.shape({}).isRequired
};

export default withRouter(PopUpLink);



// WEBPACK FOOTER //
// ./src/components/Common/GlobalPopUps/PopUpLink.js